import { render, staticRenderFns } from "./UpdateInfoModal.vue?vue&type=template&id=05c916bc"
import script from "./UpdateInfoModal.vue?vue&type=script&lang=js"
export * from "./UpdateInfoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports